import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "d-flex justify-center" }
const _hoisted_2 = { class: "w-75 content-center" }

import CreateOrUpdateModalContent from "@/components/Department/CreateOrUpdateModalContent.vue"
import getDepartmentAllParams from "@/types/responses/getDepartmentAllParams"
import getOperationOffice from "@/types/responses/getOperationOffice"
import getDepartmentResponse from "@/types/responses/getDepartment"
import RegisterModal from "@/components/Common/RegisterModal.vue"
import { DEPARTMENT_SELECTABLE_LEVEL } from '@/services/consts'
import { isSecondLevelDepartment } from "@/services/functions"
import { scrollToErrorComponent } from "@/services/validators"
import { Ref, ref, computed, onMounted } from "vue"
import Api from "@/services/api/ApiServiceFabrick"
import i18n from "@/lang/i18n"

type formType = {
  operation_office: getOperationOffice | null
  level: { key: number, label: string }
  parent: getDepartmentResponse | null
  id_for_customer: string
  name: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CreateOrUpdateModal',
  props: {
    department: {},
    modelValue: { type: Boolean },
    parentIdExistsDepartments: {},
    isDepartment: { type: Boolean },
    isChildDepartment: { type: Boolean },
    loginOrganizationId: {},
    updateAuthority: { type: Boolean },
    closeModal: { type: Function },
    showFlash: { type: Function }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit;
const form = ref({
  operation_office: null,
  level: DEPARTMENT_SELECTABLE_LEVEL[0],
  parent: null,
  id_for_customer: props.department?.id_for_customer ?? "",
  name: props.department?.name ?? ""
} as formType)

const isCreateOrUpdated: Ref<boolean> = ref(false)
const errors: Ref<any> = ref({})

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
})

onMounted(() => {
  form.value.level = setInitialLevel()
})

const title = computed(() => {
  return props.department?.id ? i18n.global.t('pages.departments.createOrUpdateModal.updateTitle') : i18n.global.t('pages.departments.createOrUpdateModal.createTitle')
})

const isDisplayExecBtn = computed(() => {
  if (props.department?.id) return props.updateAuthority
  return true
})

const departmentRequired = computed(() => {
  return props.isChildDepartment || (props.isDepartment && (!props.department?.id || props.department?.id != props.loginOrganizationId))
})

function setInitialLevel() {
  if (departmentRequired.value || props.department?.parent_id) return DEPARTMENT_SELECTABLE_LEVEL[1]
  return DEPARTMENT_SELECTABLE_LEVEL[0]
}

function createOrUpdate() {
  errors.value = {}
  isCreateOrUpdated.value = true
  const id = props.department?.id ?? null
  Api().createOrUpdateDepartment(id, requestParams()).then(() => {
    props.showFlash(i18n.global.t('pages.common.messages.success'), 'success', true)
    props.closeModal(true)
  }).catch((error) => {
    isCreateOrUpdated.value = false
    errorHandle(error.response)
  })
}

function requestParams() {
  return {
    operation_office_id: form.value.operation_office?.id ?? null,
    level: form.value.level.key,
    parent_id: isSecondLevelDepartment(form.value.level.key) ? form.value.parent?.id : null,
    id_for_customer: form.value.id_for_customer,
    name: form.value.name
  }
}

function errorHandle (res: any) {
  switch (res.status) {
    case 403:
      location.reload();
      break
    case 422:
      errors.value = res.data.errors
      scrollToErrorComponent();
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createBlock(RegisterModal, {
    modelValue: modelValue.value,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((modelValue).value = $event)),
    modalMaxWidth: "45%",
    title: title.value
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(CreateOrUpdateModalContent, {
            modelValue: form.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form).value = $event)),
            department: props.department,
            parentIdExistsDepartments: props.parentIdExistsDepartments,
            initialOperationId: undefined,
            isDepartment: props.isDepartment,
            isChildDepartment: __props.isChildDepartment,
            loginOrganizationId: props.loginOrganizationId,
            isRequired: departmentRequired.value,
            errors: errors.value
          }, null, 8, ["modelValue", "department", "parentIdExistsDepartments", "isDepartment", "isChildDepartment", "loginOrganizationId", "isRequired", "errors"])
        ])
      ])
    ]),
    buttons: _withCtx(() => [
      _createVNode(_component_v_btn, {
        class: "ma-2 reset-btn",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (__props.closeModal(false)))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(i18n).global.t('common.closeBtn')), 1)
        ]),
        _: 1
      }),
      (isDisplayExecBtn.value)
        ? (_openBlock(), _createBlock(_component_v_btn, {
            key: 0,
            class: "ma-2 exec-btn",
            loading: isCreateOrUpdated.value,
            onClick: createOrUpdate
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.common.button.conservation')), 1)
            ]),
            _: 1
          }, 8, ["loading"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})